import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../Header/Header';
import Breadcrumb from '../../common/Breadcrumb';
import Footer from '../../common/Footer';
import AuthModal from '../../common/AuthModal';
import GlobalToast from '../../common/GlobalToast/GlobalToast';
import './MainLayout.css';

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <Header />
      <Breadcrumb />
      <main className="main-layout__content">
        <Outlet />
      </main>
      <Footer />
      <AuthModal />
      <GlobalToast />
    </div>
  );
};

export default MainLayout;
